<script>
	import SecondaryStatsComponent from "./SecondaryStatsComponent.svelte";
	import {tick} from 'svelte'
	import {scrollToElement} from "./util"
	import ImageReviewDialog from "./ImageReviewDialog.svelte"
	export let lang, productCode, product

	const en = lang == 'en';

	// Filter attributes
		const facets = [
				{filter: 'Rating', labels: {en:['5 Stars', '4 Stars', '3 Stars', '2 Stars', '1 Star'], fr: ['5 étoiles', '4 étoiles', '3 étoiles', '2 étoiles', '1 étoile']}, options: [5, 4, 3, 2, 1]},
				{filter: 'Locale', labels: ['English (Canada)', 'français (Canada)'], options: ['en', 'fr']},
				{filter: "Sort By", labels: {en:["Most Relevant", "Rating Ascending", "Rating Descending", "Most Recent Ratings", "Most Helpful Ratings"], fr:["Le plus pertinent", "Note la plus élevée à la plus faible", "Note la plus basse à la plus élevée", "Notes les plus récentes", "Notes les plus utiles"]}, options: ["relevancy:a1", "Rating:asc", "Rating:desc", "SubmissionTime:desc", "TotalPositiveFeedbackCount:desc"]},
		];
		let anonymousText = en ? 'Anonymous' : 'Anonyme';
		let activeRemovalFacets = [];
		let previousActiveRemovalFacets = [];
		let activeFilters = [];
		let locale = '';
		let activeSort = '';
		let previousFilters = []
		let previousLocale = ''
		let previousSearchQuery = ''
		let previousSort = ''
		let totalResults = 0;

		let page = 0;
		let limit = 8;
		let offset = 0;      
		let isLoading = false;
		let hasNextPage = false;

		// Review attributes
		let reviews = [];
		let reviewSummary = false;
		let reviewWithPhotos = [];
		const reviewCount = en ? product?.tenantTotalReviewCount?.value : product?.tenantTotalReviewCountFr?.value;
		const averageRating = en ? product?.tenantRating?.value || 0 : product?.tenantRatingFr?.value || 0;
		let reviewElements = []

		let secondaryRatingValues = [];
		let secondaryRatings = [];

		let firstLoad = true;
		let filterReset = false;
		let loading = false;
		let searchQuery = '';

		let dialogEle;
		let currentReviewDialogIndex = null;
		let currentPhotoIndex = 0;

			// retrieve product reviews 
		async function getProductReviews(scroll=false, nextPage=0) {
				try {
						loading = true;
						const { limit, offset } = getPaginationParams(nextPage);
						const queryParams = new URLSearchParams({
								sort: activeSort || 'relevancy:a1',
								rating: activeFilters,
								localeFilter: locale,
								limit: limit,
								offset: offset
						});

						if(searchQuery) {
							//previousSearchQuery = searchQuery;
							queryParams.append('search', searchQuery);
						}


						const reviewTotalResponse = await fetch(`/_api/${lang}/bazaarvoice/reviews/${productCode}?${queryParams.toString()}`, {
								method: 'GET'
						});

						const reviewsTotal = await reviewTotalResponse.json();
						reviews = reviewsTotal?.Results 
											? reviewsTotal?.Results.map(review => {
												const vote = getCookie(`bz_feedback_${review.Id}`)
												return {
													...review,
													showThumbsUp: vote === 'POSITIVE',
													showThumbsDown: vote === 'NEGATIVE'
												};
											})
											: [];
						totalResults = reviewsTotal?.TotalResults || 0;
						page = nextPage;
						reviewWithPhotos = reviewsTotal?.reviewsWithPhotos || [];
						reviewSummary = reviewsTotal?.summary || false;
						let reviewStats = reviewsTotal?.Includes?.Products[`${productCode}`]?.ReviewStatistics || {};
						secondaryRatingValues = reviewStats.SecondaryRatingsAveragesOrder || [];
						if(secondaryRatingValues.length > 0) {
							secondaryRatings = secondaryRatingValues.map(val => {
								return {
									name: val,
									rating: reviewStats.SecondaryRatingsAverages[`${val}`]?.AverageRating
										? parseFloat(reviewStats.SecondaryRatingsAverages[`${val}`]?.AverageRating.toFixed(1))
										: 0
								}
							})
						}

						if(scroll) {
								setTimeout(() => {
										const firstReview = document.querySelector(`div[data-index="1"]`) 
										//firstReview.closest('.reviews').scrollIntoView({behavior:'smooth'})
										// const targetElement = document.querySelector('.reviews__list');
										if (firstReview) {
												scrollToElement(firstReview, -170);
										}
								}, 200);
						}

						loading = false;
				} catch (error) {
						loading = false;
						console.log('error review');
				}
		}

		async function main() {
				if (firstLoad) {
						loading = true;
						firstLoad = false;
						await getProductReviews(false, 0);
						loading = false;
				}
		}

		async function searchSubmitHandler(event) {
			const formData = new FormData(event.target);
			searchQuery = formData.get('s');
			// await getProductReviews(false);
			// setRemovalFacets();
		}

		function mapSecondaryRatings(ratings, order) {
			console.log('secondaryRatings:', ratings);
			//const orderedRatings = Object.fromEntries(order.filter(key=> key in ratings).map(key=> [key, ratings[key]]));
			return Object.entries(ratings).map(val => ({
				name: val[0],
				rating: val[1].hasOwnProperty(`Value`) ?
					parseFloat(val[1].Value.toFixed(1))
					: 0
			})).sort((a, b) => order.indexOf(a.name) - order.indexOf(b.name));
		}

			// get some reviews
		if (reviews) {
				main();
		}
		function setRemovalFacets() {
			activeRemovalFacets = {
				searchQuery,
				activeFilters,
				locale,
				activeSort
			}
			console.log('activeRemovalFacets' , activeRemovalFacets);
			// activeRemovalFacets = [previousSearchQuery, ...activeFilters, locale, activeSort];
		}
		async function filterResetHandler() {
			filterReset = true
			searchQuery = '';
			document.querySelector('#search-bazaarvoice-reviews').value = '';
			activeFilters = [];
			locale = '';
			activeSort = '';
			await getProductReviews(true, 0);
			filterReset = false;
		}

		function clearRemovalFacet(e) {
			switch(e.target.dataset.facetType) {
				case 'searchQuery':
					searchQuery = '';
					document.querySelector('#search-bazaarvoice-reviews').value = '';
					break;
				case 'activeFilters':
					activeFilters = activeFilters.filter(facet => facet != e.target.dataset.label);
					break;
				case 'locale':
					locale = '';
					break;
				case 'activeSort':
					activeSort = '';
					break;
			}
		}

		async function reviewDialogOpen(index, photoIndex) {
			currentReviewDialogIndex = index
			currentPhotoIndex = photoIndex
			// selectedReviewForDialog = {...review, photo};
			await tick()
			dialogEle.showModal()
		}
		function prevDialogReview() {

			if (currentPhotoIndex > 0) {
				currentPhotoIndex--
				return
			}
			//Moved to previous Review
			if (currentReviewDialogIndex > 0) {
				currentReviewDialogIndex--
				const prevPhotos = reviewWithPhotos[currentReviewDialogIndex].Photos
				currentPhotoIndex = prevPhotos.length -1 ;
			}
		}

		function nextDialogReview() {
			const photos = reviewWithPhotos[currentReviewDialogIndex].Photos;
			//Next photo exists;
			if (currentPhotoIndex < photos.length - 1) {
				currentPhotoIndex++
				return
			}
			//Move to next review
			if (currentReviewDialogIndex < reviewWithPhotos.length - 1) {
				currentReviewDialogIndex++
				currentPhotoIndex = 0;
			}
		}    

		async function handleFeedback(review, vote) {
			if(review.showThumbsUp || review.showThumbsDown) return;
			try {
				console.log('Feedback received for review ID:', review.Id, 'Type:', vote);
				let response = await fetch(`/${lang}/reviews/${review.ProductId}/feedback?contentId=${review.Id}&vote=${vote}`);
				response = await response.json();

				//set cookie for feedback
				document.cookie = `bz_feedback_${review.Id}=${response.feedbackResponse?.Feedback?.Helpfulness?.Vote}`

				if(response && response.feedbackResponse?.Feedback?.Helpfulness?.Vote == 'POSITIVE') {
					review.showThumbsUp = true;
				} else if (response && response.feedbackResponse?.Feedback?.Helpfulness?.Vote == 'NEGATIVE') {
					review.showThumbsDown = true;
				} else {
					review.showThumbsUp = false;
					review.showThumbsDown = false;
				}
				reviews = reviews.map(r =>
					r.id === review.Id
						? { 
								...r,
								showThumbsUp: r.showThumbsUp,
								showThumbsDown: r.showThumbsDown
							}
						: r
				);
				console.log('Feedback response:', response);
			} catch (error) {
				console.error('Error sending feedback:', error);
				
			}
			// Here you would typically send this feedback to your backend or analytics service
		}

		function getPaginationParams(page) {
			if (page === 0) {
				return { limit: 8, offset: 0 };
			}

			return {
				limit: 30,
				offset: 8 + (page - 1) * 30
			};      
		}

		$: hasNextPage = reviews.length > 0 && getPaginationParams(page).offset + reviews.length < totalResults;

		document.addEventListener('click', event => {
			let details = document.querySelectorAll('.review-filters')
			details.forEach(detail => !detail.contains(event.target) ? detail.removeAttribute('open') : '');
		});    

		// if it isn't the first load and filters change then get new reviews
		$: if (!firstLoad && !filterReset && (JSON.stringify(activeFilters) != JSON.stringify(previousFilters) || locale != previousLocale|| activeSort != previousSort || searchQuery != previousSearchQuery)) {
				previousSort = activeSort;
				previousFilters = [...activeFilters];
				previousLocale = locale;
				previousSearchQuery = searchQuery;
				setRemovalFacets();
				getProductReviews(true, 0);
		}
		// $: if(activeFilters || locale || activeSort || searchQuery) {
		//   activeRemovalFacets = [searchQuery, ...activeFilters, locale, activeSort].filter(Boolean);
		// }

		$:console.log('activeRemovalFacets' , activeRemovalFacets);
		$:console.log('searchQuery' , searchQuery);
		$:console.log('previousSearchQuery' , previousSearchQuery);

</script>

<section class="reviews">
	<div class="reviews-metadata">
		{#if reviewSummary}
			<div class="reviews-metadata--summary">
				<h4>{ lang == 'en' ? 'Summary of Reviews' : 'Résumé des évaluations'}</h4>
				<p>{reviewSummary}</p>
			</div>
			<div class="reviews-metdata--ai-warning">
				<img src="/_icons/Icon_AIGenerated.red.svg" alt="AI Generated Icon" width="16" height="16" loading="lazy"/>
				<p>{lang == 'en' ? 'AI-generated using English reviews only' : 'Généré par l’IA à l’aide d’évaluations en anglais seulement '}</p>
			</div>
			{#if secondaryRatings.length > 0}
				<SecondaryStatsComponent title={lang== 'en' ? 'Average Customer Ratings' : 'Note moyenne des clients'} secondaryRatings={secondaryRatings} />
			{/if}
		{/if}
	</div>



	<div class="review-pdp-navigation">
		<!-- PHOTO STRIP -->
		{#if reviewWithPhotos.length}
			<h4>{lang == 'en' ? 'Customer Images and Video' : 'Images et vidéos des clients'}</h4>
			<hh-horizontal-nav unstyled>
				{#each reviewWithPhotos as review, i}
					{#each review?.Photos as reviewPhoto, j}
					<img aria-label="Open Review" src="{reviewPhoto?.Sizes?.large?.Url}" height="200" width="200" loading="lazy" alt="Review thumbnail" on:click={()=> reviewDialogOpen(i, j)} on:keydown={(e) => e.key === 'Enter' && reviewDialogOpen(i, j)}/>
					{/each}
				{/each}
			</hh-horizontal-nav>
		{/if}
		<section class="search-filter-section">
			<form class="bazaarvoice-search" on:submit|preventDefault={searchSubmitHandler} >
				<fieldset>
					<input type="text" id="search-bazaarvoice-reviews" minlength="2" size="150" name="s" aria-label="Search topics and reviews" placeholder="{lang=='en'? 'Search topics and reviews' : 'Rechercher des sujets et des évaluations' }" required="">
					<button type="submit">Search</button>
				</fieldset>
			</form>
			<!-- FILTERS -->
			<section class="review-filter-section">
					{#each facets as {filter, labels, options}}
						{#if filter == "Sort By"}
							<select name="Sort By" class="Button ButtonFunctional" bind:value={activeSort} data-filter="{filter}">
								<option value="" disabled>{lang == 'en' ? 'Most Relevant' : 'Le plus pertinent'}</option>
								{#each labels[`${lang}`] as label, i}
										<option value="{options[i]}">{label}</option>
										{/each}
							</select>
						{:else if filter == "Locale"}
								<select name="Locale" class="Button ButtonFunctional" bind:value={locale} data-filter="{filter}">
									<option value="" disabled>{lang == 'en' ? 'Locale' : 'Lieu'}</option>
								{#each labels as label, i}
										<option value="{options[i]}">{label}</option>
										{/each}
							</select>
						{:else if filter == "Rating"}
								<details class="review-filters" data-filter={filter}>
									<summary class="h4 Light Chevron" >{en ? 'Rating' : 'Note'}</summary>
									<section class="review-filters-body">
										<fieldset>
											{#each labels[`${lang}`] as label, i}
													<label>
														<input type="checkbox" bind:group={activeFilters} value={options[i]} />{label}
													</label>
											{/each}

										</fieldset>
									</section>
								</details>
						{/if}
					{/each}
			</section>
			<!-- Removable Facets !> -->
			{#if Object.entries(activeRemovalFacets).length}
				<section class="removableFacets">
					{#each Object.entries(activeRemovalFacets) as [key, removableFacet]}
						{#if key == 'activeFilters' && removableFacet.length}
							{#each removableFacet as facet}
								<label>
									<input type="checkbox" on:input={clearRemovalFacet} data-label={facet} data-facet-type={key}> {facets[0].labels[`${lang}`][facets[0].labels[`${lang}`].length - facet]}
								</label>
							{/each}
						{:else if key!= 'activeFilters' && removableFacet}
							<label>
								<input type="checkbox" on:input={clearRemovalFacet} data-label={removableFacet} data-facet-type={key}>
									{#if key == 'activeSort'}
											{@const sortIndex = facets[2].options.indexOf(removableFacet)}
											{facets[2].labels[`${lang}`][sortIndex]}
									{:else if key == 'locale'}
											{removableFacet == 'en' ? 'English (Canada)' : 'Français (Canada)'}
									{:else if key == 'searchQuery'}
											{removableFacet}
									{/if}
							</label>
						{/if}
					{/each}
					{#if searchQuery || activeFilters.length || locale || activeSort}
						<label>
							<button class="clear-all-filters" on:click={filterResetHandler}>{lang == 'en' ? 'Clear All' : 'Réinitialiser'}</button>
						</label>
					{/if}
				</section>
			{/if}
			<div>
				<p>
					{#if totalResults == 0}
						{ lang == 'en' ? '0 reviews' : '0 commentaire'}
					{:else}
						{ lang == 'en'
							? `${getPaginationParams(page).offset + 1} - ${Math.min(getPaginationParams(page).offset + reviews.length, totalResults)} of ${totalResults} Reviews`
							: `${getPaginationParams(page).offset + 1} à ${Math.min(getPaginationParams(page).offset + reviews.length, totalResults)} sur ${totalResults} évaluations`
						}
					{/if}
				</p>
			</div>
		</section>
	</div>



{#if loading}
	<div class="Skeleton reviews__list">
		{#each Array(10) as item,i}
			<div data-index="{i}">
				<div class="review-item--author" >
					<span>▇▇▇▇▇▇▇▇▇</span>
					<span>▇▇▇▇▇▇▇▇▇</span>
					<span>▇▇▇▇▇▇▇▇▇</span>
				</div>
				<div class="review-item--details">
					<div>
						<div>▇▇▇▇▇▇▇▇▇▇▇▇▇▇▇▇▇▇</div>
						<div>▇▇▇▇▇▇▇▇▇▇▇▇▇▇▇▇▇▇</div>
						<div>▇▇▇▇▇▇▇▇▇▇▇▇▇▇▇▇▇▇</div>
					</div>
				</div>
				<div class="review-item--stats">
					<div>▇▇▇▇▇▇▇▇▇</div>
					<div>▇▇▇▇▇▇▇▇▇</div>
					<div>▇▇▇▇▇▇▇▇▇</div>
				</div>
			</div>
			<hr />
		{/each}
	</div>
{:else}
	<!-- REVIEW LIST -->
	<div class="reviews__list">
		{#each reviews as review, i}
			{#if i}
					<hr />
			{/if}
			<div data-index={i+1}>
				<div class="review-item--author">
					<span><strong>{review?.UserNickname ?? anonymousText}</strong></span>
					<span>{review?.UserLocation ? `${review.UserLocation}` : ""}</span>
					{#if review?.ContextDataValues?.Age?.ValueLabel}
							<small>{review.ContextDataValues.Age.ValueLabel} Years of age</small>
					{/if}
					{#if review.Badges.hasOwnProperty('StaffYes')}
						<div class="hh-badge">
								<span>
									<img src="/_icons/hh-logo.svg" alt="Home Hardware Logo" height="20" width="auto">
									Certified Staff Review
								</span>
						</div>
					{/if}
					{#if review?.SyndicationSource}
							<div class="review-syndication">
									<span>
										<img src="{review.SyndicationSource?.LogoImageUrl}" alt="Review Logo" height="20" width="auto" />
										Originally posted on {review.SyndicationSource?.Name}
									</span>
							</div>
						{/if}
				</div>
				<div class="review-item--details" data-review-index={i+1} bind:this={reviewElements[i]}>
					<div>
						<!-- <RatingInfo review={review} /> -->
						<div class="stars-layout">
							<div class="Rating" style="--rating: {review?.Rating ?? 0}"></div>
						</div>
						<h4>{review?.Title ? review.Title : review.ReviewText.slice(0, 20)}</h4>
						{#if review.SubmissionTime}
							 <div>
								 {
									 new Date(review.SubmissionTime).toLocaleDateString("en-US", {
												 month: "short",
												 day: "2-digit",
												 year: "numeric",
									 })
								 }
							 </div>
						{/if}
						{review.ReviewText}

						{#if review?.Photos && review.Photos.length}
								<hh-horizontal-nav unstyled>
										{#each review?.Photos as photo, j}
											{@const foundIndex = reviewWithPhotos.findIndex(r=> r.Id == review.Id)}
												<img src="{photo?.Sizes?.large?.Url}" height="80" width="80" loading="lazy" alt="{photo.Caption ||'Review thumbnail'}" on:click={()=> reviewDialogOpen(foundIndex, j)} on:keydown={(e) => e.key === 'Enter' && reviewDialogOpen(foundIndex, j)}/>
										{/each}
								</hh-horizontal-nav>
						{/if}
						{#if review.IsRecommended == true}
							<p class="review-item-recommend-messaging">
									<img src="/_icons/Icon_Confirmed.green.svg" alt="check icon" width="20" height="20">
									{lang == 'en'
											? 'Yes, I recommend this product.'
											: 'Yes, I recommend this product.'
									}
							</p>
						{:else if review.IsRecommended == false}
							<p class="review-item-recommend-messaging">
								<img src="/_icons/icon_cancelled.red.svg" alt="cross icon" width="20" height="20">
								{lang == 'en'
										? 'No, I do not recommend this product.'
										: 'No, I do not recommend this product.'
								}
							</p>
						{/if}

						{#if review.IsSyndicated == false}
							<div class="review-item--send-feedback">
								<p><strong>{lang == 'en' ? 'Did you find this Helpful?' : 'Avez-vous trouvé cela utile?'}</strong></p>
								<div class="reviews-btn-grp">
									<button on:click={() => handleFeedback(review, 'positive')} disabled={review.showThumbsUp || review.showThumbsDown}>
										{#if review.showThumbsUp}
												<img src="/_icons/Icon_ThumbsUp.solid_red.svg" alt="Thumbs Up Icon" width="16" height="16" loading="lazy" />
										{:else}
											<img src="/_icons/Icon_ThumbsUp.red.svg" alt="Thumbs Up Icon" width="16" height="16" loading="lazy" />
										{/if}
									</button>
									<button on:click={() => handleFeedback(review, 'negative')} disabled={review.showThumbsUp || review.showThumbsDown}>
										{#if review.showThumbsDown}
											<img src="/_icons/Icon_ThumbsDown.solid_red.svg" alt="Thumbs Down Icon"  width="16" height="16" loading="lazy"/>
										{:else}
										<img src="/_icons/Icon_ThumbsDown.red.svg" alt="Thumbs Down Icon"  width="16" height="16" loading="lazy"/>
										{/if}
									</button>
								</div>
							</div>
						{/if}

						<!-- Client Responses -->
						{#if review.ClientResponses.length}
						<section class="review-client-responses">
							{#each review.ClientResponses as clientResponse, i}
								<p class="review-client-response" data-index={i}>
									<span><strong>
										{lang == 'en'
											? `Response from ${clientResponse.Department}`
											: `Réponse de ${clientResponse.Department}`
										}
										</strong>
									</span>
									{#if clientResponse.Date}
										<span>
											{
												new Date(clientResponse.Date).toLocaleDateString("en-US", {
															month: "short",
															day: "2-digit",
															year: "numeric",
												})
											}
										</span>
									{/if}
									{#if clientResponse.Response}
										<span>{@html clientResponse.Response}</span>
									{/if}
								</p>
							{/each}
							</section>
						{/if}
					</div>
				</div>
				<div class="review-item--stats">
					{#if Object.entries(review.SecondaryRatings).length}
						<SecondaryStatsComponent title={lang== 'en' ? 'Customer Ratings' : 'Détails de la note'} secondaryRatings={mapSecondaryRatings(review.SecondaryRatings, review.SecondaryRatingsOrder)} />
					{/if}
				</div>
			</div>
		{/each}
	</div>
{/if}

</section>

<!-- Pagination-->
<section class="pagination">
	<p>
		{#if totalResults == 0}
		 { lang == 'en' ? '0 reviews' : '0 commentaire'}
		{:else}
			{ lang == 'en'
				? `${getPaginationParams(page).offset + 1} - ${Math.min(getPaginationParams(page).offset + reviews.length, totalResults)} of ${totalResults} Reviews`
				: `${getPaginationParams(page).offset + 1} à ${Math.min(getPaginationParams(page).offset + reviews.length, totalResults)} sur ${totalResults} évaluations`
			}
		{/if}
	</p>
	{#if hasNextPage || page > 0}
		<div class="pagination-btn-group">
				<button disabled={loading || page === 0} on:click={() => getProductReviews(true, page - 1)}>‹</button>
				<button disabled={loading || !hasNextPage} on:click={() => getProductReviews(true, page + 1)}>›</button>
		</div>
	{/if}
</section>

<!-- Dialog element for selectedReview-->
{#if currentReviewDialogIndex !== null}
	 <dialog class="ReviewDialog" bind:this={dialogEle}>
		<button on:click={()=> dialogEle.close()}><img src="/_icons/icon.close-black.svg" class="Icon Bigger" alt="close email popup icon"></button>
		<div>
			<ImageReviewDialog lang={lang} selectedReviewForDialog={reviewWithPhotos[currentReviewDialogIndex]} photoIndex={currentPhotoIndex} mapSecondaryRatings={mapSecondaryRatings}>

						<!-- Previous -->
						<button
							slot="left-arrow"
							class="nav left"
							on:click={prevDialogReview}
							disabled={currentReviewDialogIndex === 0 && currentPhotoIndex === 0}
							aria-label="Previous review"
						>
						</button>

						<!-- Next -->
						<button
							slot="right-arrow"
							class="nav right"
							on:click={nextDialogReview}
							disabled={currentReviewDialogIndex === reviewWithPhotos.length - 1 && currentPhotoIndex === reviewWithPhotos[currentReviewDialogIndex].Photos.length - 1}
							aria-label="Next review"
						>
						</button>

					<svelte:fragment slot="horizontal_images">
						<hh-horizontal-nav unstyled>
								{#each reviewWithPhotos[currentReviewDialogIndex]?.Photos as photo, j}
									<img src="{photo?.Sizes?.large?.Url}" height="80" width="80" loading="lazy" alt="{photo.Caption ||'Review thumbnail'}" on:click={()=> currentPhotoIndex = j} on:keydown={(e) => e.key === 'Enter' && (currentPhotoIndex = j) } class:selected={j === currentPhotoIndex}/>
								{/each}
						</hh-horizontal-nav>
					</svelte:fragment>
				</ImageReviewDialog>
			
		</div>
	 </dialog>
{/if}


<style>
	/* GLOBAL TOKENS */
/* :root {
	--gap: 16px;
	--radius: 12px;
	--border: #e5e7eb;
	--text: #111;
	--muted: #6b7280;
	--accent: #d62828;
} */


/* WRAPPER */
.reviews {
	display: flex;
	flex-direction: column;
	gap: 32px;
	margin: 24px 0;
}

.reviews-metadata {
	display: grid;
	grid-template-columns: 73% 1fr;
	gap: calc(var(--gap));
	border-bottom: 1px solid var(--hh-grey);
}

.reviews-metadata--summary {
	/* width: 60%; */
	display: flex;
	flex-direction: column;
	gap: calc(var(--gap) / 2);
	flex-basis: 73%;
}
.reviews-metadata--summary > p {
	width: 86%;
}
.reviews-metdata--ai-warning {
	display: flex;
	gap: calc(var(--gap) / 2);
	flex-basis: 70%;
}
.review-item--send-feedback{
	display: flex;
	align-items: center;
	gap: calc(var(--gap) / 4);
}
.review-item--send-feedback .reviews-btn-grp {
	display: inline-flex;
	gap: calc(var(--gap) / 3);
	margin-bottom: 5px;
}
.reviews-metdata--ai-warning {
	order: 1;
	display: flex;
	gap: calc(var(--gap) / 4);
	align-items: center;
	margin-left: auto;
}
.reviews-btn-grp > button {
	border: none;
	background-color: transparent;
	cursor: pointer;
}
.reviews-btn-grp > button:disabled {
	cursor: initial;
}

.search-filter-section {
	border-bottom: 1px solid var(--hh-grey);
}

.bazaarvoice-search {
		padding: 0;
		border: 0;
		margin: 0;
		white-space: nowrap;
		
}

.bazaarvoice-search input[type="text"] {
	-webkit-appearance: none;
	appearance: none;
	border: none;
	font: inherit;
	padding: 0;
	background: transparent;
	outline: none;
	min-width: 200px;
	max-width: 400px;
	box-sizing: border-box;  
}

.bazaarvoice-search fieldset {
	padding: 0;
	margin: 0;
	display: grid;
	grid-auto-flow: column;
	grid-template-columns: 1fr auto;
	grid-gap: calc(var(--gap) / 2);
	align-items: center;
	justify-content: flex-end;
	background: #fff;
	border-radius: 5px;
	padding: 0 1em;
	border: 2px solid var(--hh-grey);  
}

.bazaarvoice-search fieldset button {
	-webkit-appearance: none;
	appearance: none;
	border: none;
	font: inherit;
	padding: calc(var(--gap) / 3) 0;
	width: var(--gap);
	background: transparent url(https://www.homehardware.ca/_svg/icon.search-red.svg) no-repeat 50% 50% / var(--gap);
	text-indent: -444rem;
	display: inline-block;
	cursor: pointer;
	background-size: 80%;
}


.review-filter-section {
		display: flex;
		gap: calc(var(--gap) / 2);
		padding: calc(var(--gap)/2) 0 var(--gap);
		flex-wrap: wrap;
}

.review-filters {
		border: 2px solid var(--hh-grey);
		border-radius: 4px;
		padding: 0;
		font-size: var(--buttonfontsize);
}
/* .review-filters[data-filter="Rating"] {
	 width: 21ch;

	& > .review-filters-body {
		width: 21ch;
	}
} */
[data-filter="Locale"] {
	/*
	width: 21ch;
	*/
	& > option:disabled {
		display: none;
	}
}
[data-filter="Sort By"] {
	margin-left: auto !important;
	/** width: 35ch; */
	& > option:disabled {
		display: none;
	}
}
.review-filters > summary {
		padding: 0.6em 2em 0.6em 1em;
		background: url(https://homehardware.sirv.com/hh/icons/icon-chevron-down.black.svg) no-repeat calc(100% - 0.5em) center / .8em;
}
.review-filters[open] > summary {
		background-image: url(https://homehardware.sirv.com/hh/icons/icon-chevron.black.svg);
}
.review-filters-body {
		max-height: 30vh;
		overflow-y: auto;
		position: absolute;
		z-index: +1;
		background: var(--hh-white);
		border: 2px solid var(--hh-grey);
		padding: .6em 1em;
		transform: translateX(-2px) translateY(0.75em);
		border-radius: 4px;
		box-sizing: border-box;
}

	@supports (scrollbar-color:var(--hh-red) var(--hh-red)) {
		.review-filters-body {
			scrollbar-color: var(--hh-red) #e4e4e4;
			scrollbar-width: thin;
		}
	}

.reviews .review-pdp-navigation > section {
	display: flex;
	flex-direction: column;
	gap: calc(var(--gap) / 2);

	&  > form {
		max-width: 75ch;
	}
}

.removableFacets {
		display: flex;
		flex-wrap: wrap;
		gap: calc(var(--gap) * 0.75);
		border: 0;
		padding: 0;
		margin: 0;
	}
	.removableFacets:empty {
		display: none
	}
	.removableFacets > label {
		background: var(--hh-light-grey);
		display: flex;
		flex-direction: row-reverse;
		align-items: center;
		border-radius: 5px;
		padding: calc(var(--gap) * 0.5) calc(var(--gap) * 0.75);
		text-transform: capitalize;
	}
	.removableFacets > label input[type="checkbox"] {
		appearance: none;
		border: none;
		width: 1.25em;
		height: 1.25em;
		/* margin: 0 0 0 calc(var(--gap) / 4); */
		cursor: pointer;
		background: none;
		border: 0 !important;
	}
	.removableFacets > label input[type="checkbox"]:checked {
		color: var(--hh-black);
	}
	.removableFacets > label input::after {
		content: url('https://www.homehardware.ca/_icons/icon-x.black.svg');
	}

	.clear-all-filters {
		cursor: pointer;
		background-color: var(--hh-light-grey);
		border: none;
	}
	.reviews__list {
		overflow-y: auto;
	}

	.reviews__list > div {
		display: grid;
		gap: var(--gap);
		grid-template-columns: 22% 1fr auto;
		/* flex-direction: row; */
	}
	.review-item--author, .review-item--details, .review-item--stats {
		order: 1;
	}
	.review-item--author  {
		display: flex;
		flex-direction: column;
		/* width: 22%; */
		margin-top: 1.5rem;
	}
	.review-item-recommend-messaging {
		display: flex;
		gap: calc(var(--gap) /2);
		align-items: center;
	}
	.review-client-response {
		display: flex;
		flex-direction: column;
	}
	.review-syndication > span, 
	.hh-badge > span {
		display: inline-flex;
		gap: calc(var(--gap) / 3);
		align-items: center;
		padding: 5px;
		border: 1px solid var(--hh-grey);
		border-radius: 5px;
	}
	.review-item--details {
		/* width: 78%; */
		display: flex;
		justify-content: space-between;
		gap: var(--gap);
	}
	.review-item--details > div:first-child {
		flex-basis: 100%;
	}
	.review-item--details .stars-layout {
		margin-bottom: 0.5rem;
	}
	.review-item--stats{
		width: 25rem;
	}

	@media (max-width: 900px) {
		.reviews-metadata {
			grid-template-columns: 1fr;
			grid-template-rows: auto;
		}
		.reviews-metadata--summary > p {
			width: 100%;
		} 
		.reviews-metdata--ai-warning {
			margin-left: 0;
		}
		.reviews__list > div {
			grid-template-columns: 1fr;
			grid-template-rows: auto;
		}
		.review-item--author, .review-item--details, .review-item--stats {
			width: 100%;
		}
		.review-item--author {
			order: 2;
			margin-top: 0;
		}
		.review-item--details {
			order: 0;
		}
		.review-item--stats {
			order: 1;
		}

	}

	@media (max-width: 500px) {
		[data-filter="Sort By"] {
			margin-left: 0 !important;
		}
	}

	.pagination {
		background-color: #f5f5f5;
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: var(--gap);
	}
	.pagination > *:first-child {
		margin: 0 10px;
	}
	.pagination-btn-group button {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 2rem;
		height: 3rem;
		cursor: pointer;
		font-size: 1.65rem;
	}
	.pagination-btn-group button:disabled {
		cursor: initial;
		opacity: 0.5;
	}


dialog.ReviewDialog {
	background: #fff;
	padding: var(--gap) !important;
	padding-right: calc(var(--gap) / 0.5) !important;
	border-radius: .5rem;
	border: none;
	max-width: min(1024px, 90dvw) !important;
	max-height: 80dvh;
	animation: fade-in .3s;
	transform: translate3d(0, 0, 0);
	/* position: relative; */
}

button.nav.left, button.nav.right {
	position: absolute;
	font-size: 1.5rem;
	top: 46%;
	cursor: pointer;
	padding: var(--gap) calc(var(--gap) * 0.75);
	background: var(--hh-grey);
	border: 1px solid var(--hh-light-grey);
}
button.nav.left {
	left: 0;
	/* transform: translateX(-20px); */
	border-radius: 0 5px 5px 0;
}
button.nav.left:after{
	position: absolute;
	top: 0;
	right: -30%;
	content: '';
	aspect-ratio: 1/1;
	width: 100%;
	height: 100%;
	background: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI2LjMuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zOnZlY3Rvcm5hdG9yPSJodHRwOi8vdmVjdG9ybmF0b3IuaW8iCgkgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiIHZpZXdCb3g9IjAgMCAyMCAyMCIKCSBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAyMCAyMDsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPgoJLnN0MHtmaWxsLXJ1bGU6ZXZlbm9kZDtjbGlwLXJ1bGU6ZXZlbm9kZDt9Cjwvc3R5bGU+CjxwYXRoIHZlY3Rvcm5hdG9yOmxheWVyTmFtZT0iTGF5ZXIgMSIgY2xhc3M9InN0MCIgZD0iTTE0LjMsMTAuNmwtNi42LDYuNmMtMC4zLDAuMy0wLjgsMC4zLTEuMiwwbC0wLjgtMC44Yy0wLjMtMC4zLTAuMy0wLjgsMC0xLjIKCUwxMSwxMEw1LjcsNC43Yy0wLjMtMC4zLTAuMy0wLjgsMC0xLjJsMC44LTAuOGMwLjMtMC4zLDAuOC0wLjMsMS4yLDBsNi42LDYuNkMxNC42LDkuNywxNC42LDEwLjMsMTQuMywxMC42eiIvPgo8L3N2Zz4K") no-repeat 100% 50% / 1rem;
	transform: rotate(180deg);
}

button.nav.right {
	right: 0;
	/* transform: translateX(20px); */
	border-radius: 5px 0 0 5px;
}
	button.nav.right:after{
		position: absolute;
		top: 0;
		right: 30%;
		content: '';
		aspect-ratio: 1/1;
		width: 100%;
		height: 100%;
		background: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI2LjMuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zOnZlY3Rvcm5hdG9yPSJodHRwOi8vdmVjdG9ybmF0b3IuaW8iCgkgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiIHZpZXdCb3g9IjAgMCAyMCAyMCIKCSBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAyMCAyMDsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPgoJLnN0MHtmaWxsLXJ1bGU6ZXZlbm9kZDtjbGlwLXJ1bGU6ZXZlbm9kZDt9Cjwvc3R5bGU+CjxwYXRoIHZlY3Rvcm5hdG9yOmxheWVyTmFtZT0iTGF5ZXIgMSIgY2xhc3M9InN0MCIgZD0iTTE0LjMsMTAuNmwtNi42LDYuNmMtMC4zLDAuMy0wLjgsMC4zLTEuMiwwbC0wLjgtMC44Yy0wLjMtMC4zLTAuMy0wLjgsMC0xLjIKCUwxMSwxMEw1LjcsNC43Yy0wLjMtMC4zLTAuMy0wLjgsMC0xLjJsMC44LTAuOGMwLjMtMC4zLDAuOC0wLjMsMS4yLDBsNi42LDYuNkMxNC42LDkuNywxNC42LDEwLjMsMTQuMywxMC42eiIvPgo8L3N2Zz4K") no-repeat 100% 50% / 1rem;
	}

	button.nav.left:disabled,
	button.nav.right:disabled {
		display: none;
	}
	@media (max-width: 900px) {
		dialog.ReviewDialog {

			padding-right: var(--gap) !important;
		}

		dialog.ReviewDialog:has(figure) > button {
			background: var(--hh-white) !important;
		}
	}


</style>



